import { LAUNCH_MODE } from 'config/_const';
import { useCallback, useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { getAssetInfoFromMarketService } from 'service/asset-current-information/actions';
import { getPredictedPrice } from 'service/assets/actions';
import AssetViewModel from 'view-model/Assets/AssetViewModel';
import IUseAssetPredictPrice from './IUseAssetPredictPrice';
import IUseAssetPredictPriceProps from "./IUseAssetPredictPriceProps";

const useAssetPredictPrice = ({ asset }: IUseAssetPredictPriceProps): IUseAssetPredictPrice => {
    const dispatch = useDispatch();
    const assetViewModel: AssetViewModel = useMemo(() => new AssetViewModel(asset), [asset]);

    const fetchPredictPrice = useCallback((predictAsset: AssetViewModel): void => {
        const forcedSM: boolean = predictAsset.IsWhiteListedPurchaseOpen || predictAsset.PackEnabled;
        if (!predictAsset.InitialSaleDone && !forcedSM && predictAsset.LaunchMode === LAUNCH_MODE.DEFAULT) {
            dispatch(getPredictedPrice(predictAsset.AssetId, 1, false, true));
            return
        }
        dispatch(getAssetInfoFromMarketService(assetViewModel.AssetId));
        return
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        fetchPredictPrice(assetViewModel);
    }, [assetViewModel, assetViewModel.AssetId, fetchPredictPrice]);

    return {}
}

export default useAssetPredictPrice;